// extracted by mini-css-extract-plugin
module.exports = {"container":"kf","disabled":"lf","bgBlack":"mf","content":"nf","countdown":"of","topCaption":"pf","topHeading":"qf","heading":"rf","copy":"sf"};